import { render, staticRenderFns } from "./activeRule.vue?vue&type=template&id=fcba198e&scoped=true&"
import script from "./activeRule.vue?vue&type=script&lang=js&"
export * from "./activeRule.vue?vue&type=script&lang=js&"
import style0 from "./activeRule.vue?vue&type=style&index=0&id=fcba198e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcba198e",
  null
  
)

export default component.exports